import { Client, cacheExchange, fetchExchange } from "urql";
import Cookies from "js-cookie";

const url = "/graphql";

const client = new Client({
  exchanges: [cacheExchange, fetchExchange],
  fetchOptions: () => {
    const token = Cookies.get("TOKEN");
    return {
      headers: {
        Authorization: token ? `${token}` : "",
      },
    };
  },
  requestPolicy: "network-only",
  url,
});

export { client };
